import { environment } from "../environments/environment";


export class AppSettings {
  public static API_URI = environment.backend;
}
